// 对用户中心的对象进行排序和加密
import CryptoJS from "crypto-js/crypto-js";
export function sortAndEncrypt(obj?: any) {
  const ts: any = Date.parse(new Date() + "") + "";
  let keyValue = import.meta.env.VITE_APP_KEY + ts;
  // 创建一个新的对象，其key按照排序后的顺序排列
  const sortedObj: any = {};
  if (obj) {
    const sortedKeys = Object.keys(obj).sort();
    for (let i = 0; i < sortedKeys.length; i++) {
      const key = sortedKeys[i];
      sortedObj[key] = obj[key];
      if (typeof obj[key] === "object") {
        //对象里也得进行key排序，这里要判断是对象还是数组还是对象数组，暂时没做
        keyValue += JSON.stringify(obj[key]);
      } else {
        keyValue += String(obj[key]);
      }
    }
  }
  const sign = CryptoJS.SHA256(keyValue).toString(CryptoJS.enc.Hex);
  sortedObj["ts"] = ts;
  sortedObj["sign"] = sign;
  return sortedObj;
}
export function getUniqueDeviceIdentifier() {
  let uid = window.localStorage.getItem("device_uid");
  if (!uid) {
    const max = Math.pow(10, 16) - 1; // 最大16位数值
    const randomNumber = Math.floor(Math.random() * max); // 生成随机整数
    uid = String(randomNumber).padStart(16, "0"); // 保证结果为16位，不足时左侧补零
    window.localStorage.setItem("device_uid", uid); // 存储在localStorage中
  }
  return uid;
}
export function setToken(token: any) {
  localStorage.setItem("AI-Token", token);
}
export function getToken() {
  return localStorage.getItem("AI-Token") || "";
}
export function removeToken() {
  localStorage.removeItem("AI-Token");
}
